var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIconClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_5467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.444336,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_5467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73082 22.7135L3.48849 16.7058C3.17183 16.0289 2.92792 15.3353 2.75677 14.6249C2.5856 13.9146 2.50002 13.1877 2.50002 12.4443C2.50002 11.1301 2.74935 9.89515 3.24802 8.73934C3.74669 7.5835 4.42344 6.57809 5.27827 5.72309C6.13312 4.86809 7.13836 4.19121 8.29399 3.69246C9.44961 3.19371 10.6844 2.94434 11.9983 2.94434C13.3123 2.94434 14.5473 3.19367 15.7034 3.69234C16.8596 4.191 17.8653 4.86775 18.7205 5.72259C19.5757 6.57744 20.2528 7.58268 20.7516 8.73831C21.2505 9.89393 21.5 11.1287 21.5 12.4426C21.5 13.7566 21.2506 14.9916 20.7518 16.1477C20.2531 17.3039 19.5762 18.3096 18.7212 19.1648C17.8662 20.02 16.8608 20.6971 15.705 21.196C14.5492 21.6948 13.3142 21.9443 12 21.9443C11.2566 21.9443 10.5297 21.8587 9.81937 21.6875C9.10902 21.5164 8.41539 21.2725 7.73847 20.9558L1.73082 22.7135ZM3.94999 20.4943L7.14999 19.5443C7.39614 19.4776 7.63365 19.4494 7.86249 19.4597C8.09134 19.47 8.32051 19.5315 8.54999 19.6443C9.08333 19.911 9.64166 20.111 10.225 20.2443C10.8083 20.3776 11.4 20.4443 12 20.4443C14.2333 20.4443 16.125 19.6693 17.675 18.1193C19.225 16.5693 20 14.6776 20 12.4443C20 10.211 19.225 8.31931 17.675 6.76931C16.125 5.21931 14.2333 4.44431 12 4.44431C9.76666 4.44431 7.87499 5.21931 6.32499 6.76931C4.77499 8.31931 3.99999 10.211 3.99999 12.4443C3.99999 13.0443 4.06666 13.636 4.19999 14.2193C4.33333 14.8026 4.53333 15.361 4.79999 15.8943C4.91666 16.111 4.98076 16.3401 4.99229 16.5818C5.00384 16.8235 4.97308 17.061 4.89999 17.2943L3.94999 20.4943ZM11.25 16.1943H12.75V13.1943H15.75V11.6943H12.75V8.69434H11.25V11.6943H8.25002V13.1943H11.25V16.1943Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIconClicked);
export default __webpack_public_path__ + "static/media/comment-icon-clicked.1767c841bb7c6d10bc0e522c56e83db5.svg";
export { ForwardRef as ReactComponent };